import React from "react";
import "./style.css";
function Companies() {
  return (
    <div className="companies-container">
      <div className="left-side-container-comp">
        <p>We wouldn't have gotten here without you.</p>
      </div>
      <div className="right-side-container-comp">
        <img
          src="https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/companies.svg"
          alt="Companies"
        />
      </div>
    </div>
  );
}

export default Companies;
